export default {
    "cellwine_storage": "CELLWINE 銅板酒窖",
    "add": "加入",
    "bottle": "瓶",
    "bottle_number": "瓶數",
    "send": "送出",
    "comfirm": "確定",
    "env_intro": "環境介紹",
    "service_desc": "服務說明",
    "charges": "收費標準",
    "storage_winelist": "藏酒列表",
    "shipping_wine": "我要寄酒",
    "store_wine": "我要存酒",
    "order_list": "使用紀錄",
    "order_list_tip": "點擊可顯示使用紀錄明細",
    "service_action": "類別",
    "carriage": "托運車",
    "register": "註冊",
    "login": "登入",
    "logout": "登出",
    "get_verification_code": "取得驗證碼",
    "validate": "驗證",
    "forgetpassword_title": "忘記密碼",
    "forgetpassword_desc": "請輸入當初註冊的 Email，我們將寄送一封重置密碼信給您。",
    "enter_verification_code": "請輸入簡訊驗證碼",
    "delivery_info": "寄送資訊",
    "recipient": "收件者",
    "address": "地址",
    "title": "名稱",
    "sender": "寄件者",
    "phone": "電話",
    "email": "E-mail",
    "name": "姓名",
    "real_name": "真實姓名",
    "gender": "性別",
    "birthday": "出生日期",
    "currency": "幣別",
    "TWD": "TWD",
    "filter": "篩選",
    "multi_select": "多選",
    "country": "國家",
    "country_fr": "法國",
    "country_it": "義大利",
    "country_us": "美國",
    "country_au": "澳洲",
    "country_es": "西班牙",
    "country_others": "其他",
    "region_burgundy": "勃艮第",
    "region_bordeaux": "波爾多",
    "region_champagne": "香檳",
    "filter_others": "其他",
    "est_value": "市場估值",
    "est_value_tip": "(最低-最高)",
    "minimum": "最小值",
    "maximum": "最大值",
    "wine_color": "酒顏色",
    "color": "顏色",
    "wine_type": "酒種",
    "vintage": "年份",
    "vintage_tip": "(最早-最晚)",
    "volume": "容量",
    "red_wine": "紅酒",
    "white_wine": "白酒",
    "rose_wine": "粉紅酒",
    "wine_type_still": "靜態酒",
    "wine_type_sparkling": "氣泡酒",
    "wine_type_fortified": "加烈酒",
    "wine_type_dessert": "甜酒",
    "city": "縣市",
    "area": "地區",
    "last_updated": "更動時間",
    "edit": "編輯",
    "delivery": "托運",
    "check_photo": "查看照片",
    "date": "日期",
    "order_number": "訂單編號",
    "notes": "筆記",
    "prediction_flat": "持平",
    "prediction_up": "上漲",
    "prediction_down": "下跌",
    "value": "市場估值",
    "avg_cost": "平均成本",
    "profit_and_loss": "損益",
    "prediction": "預測",
    "prediction_value": "預測市值",
    "region": "產區",
    "winery": "酒莊",
    "grape": "葡萄種類",
    "price": "金額",
    "setting": "個人資訊",
    "setting_edit": "個人資訊修改",
    "credit_card_edit": "帳單資訊修改",
    "basic_setting": "基本資訊",
    "credit_card_setting": "帳單資訊",
    "add_card": "新增卡片",
    "add_credit_card": "更新信用卡",
    "add_credit_card_1": "新增信用卡",
    "update_credit_card": "更新信用卡資料",
    "udpate_invoice_info": "修改發票資訊",
    "set_default": "設為預設",
    "default": "預設",
    "year": "年",
    "month": "月",
    "day": "日",
    "female": "女",
    "male": "男",
    "select_gender": "請選擇性別",
    "zip_code": "郵遞區號",
    "payment_method": "付款方式",
    "invoice_info": "常用發票資訊",
    "update_invoice_info": "更新發票資訊",
    "select": "選擇",
    "add_to_shipping_cart": "加入托運車",
    "into_storage_date": "入窖日期",
    "previous": "上一步",
    "re_verify": "更新電話資料",
    "re_verify_title": "重新驗證電話",
    "update_phone_btn": "更新電話號碼",
    "verification_code": "驗證碼",
    "save": "儲存",
    "card_no": "卡片號碼",
    "expiry_date": "有效期限",
    "cvc": "檢查碼",
    "cvc_position": "位於卡片背面三碼",
    "new": "新增",
    "in_process": "尚未達成",
    "available": "可使用",
    "used": "已使用",
    "expired": "已過期",
    "date_of_use": "使用日期",
    "order_no_of_use": "使用之訂單編號",
    "coupon_name": "優惠券名稱",
    "coupon_cont": "優惠內容說明",
    "event_deadline": "活動截止日期",
    "desc": "說明",
    "fee": "費用",
    "fee_unit_price": "元/瓶",
    "coupon_fee": "扣抵" ,
    "payment_total": "總額",
    "achieving_rate": "達成率",
    "inbound_fee_comfirm": "入窖確認付款",
    "outbound_fee_comfirm": "託運車確認付款",
    "inbound_item": "入窖項目",
    "outbound_item": "出窖項目",
    "use_coupon": "使用優惠券",
    "payment_comfirm": "確認付款",
    "inbound_detail": "入窖明細",
    "outbound_detail": "託運明細",
    "price_detail": "詳細收費標準",
    "inbound_list": "入窖明細列表",
    "inbound_subtitle": "已寄達（暫存處理中心）",
    "create_date": "建立日期",
    "inbound_detail_title": "明細確認並付款",
    "pay": "付款",
    "inbound_comfirm": "入窖明細確認",
    "back_to_inbound_list": "返回入窖明細列表",
    "credit_card_error_msg": "*信用卡資料不完整或有誤",
    "no_data": "目前暫無資料",
    "price_data_process": "資料處理費",
    "price_data_process_intro_title": "按瓶入庫收取，單次收費",
    "price_data_process_intro_1": "* 處理費可以幫助 CELLWINE 持續讓您享受更優質的藏酒服務，",
    "price_data_process_intro_2": "其中包含酒標辨識系統維運費、倉管服務費、系統資安維護費。"
}